/** @deprecated use tokens instead @soluto-private/aui-tokens */
export const colors = {
  primaryBrighter: '#cb5aff',
  primaryBright: '#a839f3',
  primaryDeep: '#8223d2',
  primaryDeeper: '#6700b8',
  secondaryBrighter: '#6b8bff',
  secondaryBright: '#4a68f9',
  secondaryDeep: '#2743cc',
  secondaryDeeper: '#253baa',
  brandGreenBrighter: '#6efac3',
  brandGreenBright: '#00e7a1',
  brandGreenDeep: '#00b574',
  brandGreenDeeper: '#0b8350',
  brandTennis: '#d2fa46',
  white: '#ffffff',
  black: '#000000',
  neutralBrightest: '#f0f0f5',
  neutralBrighter: '#e6e6eb',
  neutralBright: '#d5d6da',
  neutralDeep: '#a5aaaf',
  neutralDeeper: '#6e767d',
  neutralDeepest: '#333f48',
  disabledBackground: '#e6e6eb',
  disabledText: '#a5aaaf',
  errorBright: '#ff5070',
  //error-lighter-1
  errorDeep: '#db1b1b',
  //error
  warningBright: '#f9d51c',
  //warning-lighter-1
  warningDeep: '#edb800',
  //warning
  successBright: '#37e7a7',
  //success-lighter-1
  successDeep: '#00bf63',
  successDeeper: '#008662',
  //success
  focus: '#0047e1'
};
export const gradients = {
  darkAngle1: `linear-gradient(136deg, ${colors.primaryDeeper} 0%, #A90AD3 100%)`,
  darkAngle2: `linear-gradient(315deg, ${colors.primaryDeeper} 0%, #A90AD3 100%)`,
  darkAngle3: `linear-gradient(0deg, ${colors.primaryDeeper} 0%, #A90AD3 100%)`,
  darkAngle4: `linear-gradient(0deg, #A90AD3 0%, ${colors.primaryDeeper} 100%)`,
  lightAngle1: 'linear-gradient(136deg, #FBF2FF 0%, #EBF9FF 100%)',
  lightAngle2: 'linear-gradient(315deg, #FBF2FF 0%, #EBF9FF 100%)',
  lightAngle3: 'linear-gradient(0deg, #FBF2FF 0%, #EBF9FF 100%)',
  lightAngle4: 'linear-gradient(0deg, #EBF9FF 0%, #FBF2FF 100%)'
};

/** @deprecated */